// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { MonolithImageSizeFragmentDoc } from '../../monolithImageSize.fragment.generated';
import { ThreeSixtyFragmentDoc } from '../three-sixty/ThreeSixty.fragment.generated';
import { CatalogueVideoFragmentDoc } from '../../../graphql/api/product/catalogueVideo.fragment.generated';
export const ProductGalleryFragmentDoc = `
    fragment productGallery on CatalogueProduct {
  productName
  suffix
  images {
    __typename
    id
    url
    sizes(names: [W250, W320, W480, W768, W1024, W1280, W1440, W1920, W2560]) {
      ...monolithImageSize
    }
  }
  ... on CatalogueJewellery {
    images360 {
      ...threeSixty
    }
    video {
      ...catalogueVideo
    }
  }
  ... on CatalogueEngagementRing {
    images360 {
      ...threeSixty
    }
    video {
      ...catalogueVideo
    }
    centreStoneConstraints {
      shape {
        translation(locale: $locale) {
          name
        }
      }
    }
  }
  ... on CatalogueWeddingRing {
    images360 {
      ...threeSixty
    }
    video {
      ...catalogueVideo
    }
  }
}
    `;